<template>
  <div class="w-100 h-100 flex flex-column">
    <dv-border-box-7>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="deptCloseRateEchart"></div>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="本月部门问题关闭率，按问题创建时间查询，已关闭问题数 / 问题总数， 按责任人部门分组显示！"
          placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "lpa-center",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("deptCloseRateEchart")
      );

      var data = this.dataList;

      const xAxis = [];
      const lineData = [];
      const barData = [];
      const closedCount = [];
      const actualCount = [];
      let periodText = "";
      data.forEach((item) => {
        switch (item.period) {
          case "year":
            periodText = "年";
            break;
          case "month":
            periodText = "月";
            break;
          case "day":
            periodText = "日";
        }
        this.tableTitle = periodText;
        xAxis.push(item.periodValue);
        lineData.push(item.issueCount);
        closedCount.push(item.closedCount);
        if (item.issueCount == 0) {
          barData.push(0);
        } else {
          barData.push(
            parseInt((item.closedCount / item.issueCount) * 100 + "", 0)
          );
        }
      });


      //自适应开始--------------------------------------
      var fontSize = 12;
      var symbolOffset = 12;
      var margin = 8;
      var yName = '问题总数';
      var yNameGap = symbolOffset;
      var c=document.getElementById("myCanvas");
      var ctx=c.getContext("2d");
      ctx.font="12px none";
      var gridTop = symbolOffset + fontSize + 2;
      if(yName == null){
        gridTop = symbolOffset;
      }
      var gridLeft = 0;
      var gridBottom = fontSize + margin + 2;
      var gridRight = 0;
      var rotate = 0;

      var yLable1 = "";
      var yMax1 = -1;

      lineData.forEach((yv) => {
        if(yv > yMax1){
          yMax1 = yv;
        }
      });

      if(yMax1.toString().indexOf('.') != -1){
        yLable1 = yMax1.toString() + "0";
      }else{
        yLable1 = yMax1.toString() + ".0";
      }

      var yMax2 = -1;
      barData.forEach((yv) => {
        if(yv > yMax2){
          yMax2 = yv;
        }
      });
      var yLable2 = yMax2.toString();
      yLable2 = yLable2 + " %";
      gridLeft = ctx.measureText(yLable1).width + margin;
      gridRight = ctx.measureText(yLable2).width + margin;
      var gridWidth = (lineEchart.getWidth() - gridRight - gridLeft) / xAxis.length;
      var lastWidth = 0;
      var xdataIndex = 0;
      var maxWidth = 0;

      xAxis.forEach((text) => {
        var thisWidth = ctx.measureText(text).width;

        if(thisWidth > maxWidth){
          maxWidth = thisWidth;
        }
        if(lastWidth == 0){
          //第一个
          if((thisWidth / 2) > gridLeft){
            rotate = 45;
          }
        }

        if((thisWidth / 2 + lastWidth / 2) > gridWidth){
          rotate = 45;
        }

        if(xdataIndex == (xAxis.length - 1)){
          //最后一个
          if((thisWidth / 2) > gridRight){
            rotate = 45;
          }
        }
        lastWidth = thisWidth;
        xdataIndex++;
      });

      if(rotate == 45){
        gridBottom = Math.sqrt(maxWidth * maxWidth / 2) + margin + fontSize / 2;
        if(gridBottom > lineEchart.getHeight() /  3 * 1){
          gridBottom = lineEchart.getHeight() /  3 * 1;
        }
      }
      //自适应结束--------------------------------------
      var option = {
        title: {
          text: "月部门关闭率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.18),
          },
        },
        grid: {
          top: gridTop + 20,
          left: gridLeft,
          right: gridRight,
          bottom: gridBottom,
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["问题总数", "关闭数", "关闭率"],
          right: 0,
          textStyle: {
            color: "#ffffff", //字体颜色,
            fontSize: this.fontSize(0.10),
          },
          itemGap: 2,
          itemWidth: 12,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 0,
              rotate: rotate,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "问题总数",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            axisLabel: {
              margin: margin,
              formatter: "{value}",
              textStyle: {
                color: "#fff",
                fontSize: fontSize,
              },
            },
            axisLine: {
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "关闭率",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            axisLabel: {
              formatter: "{value} %",
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
            axisLine: {
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            color: ["#CCCCCC"],
            name: "问题总数",
            type: "bar",
            barMaxWidth: "30",
            data: lineData,
            barGap: "-100%", // Make series be overlap
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#CCCCCC",
                    fontSize: this.fontSize(0.14),
                  },
                },
              },
            },
          },
          {
            color: ["#3398DB"],
            name: "关闭数",
            type: "bar",
            barMaxWidth: "30",
            data: closedCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#3398DB",
                    fontSize: this.fontSize(0.14),
                  },
                },
              },
            },
          },
          {
            name: "关闭率",
            type: "line",
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: { //改变折线点的颜色
                lineStyle: {
                  color: "#F25346", //改变折线颜色
                },
              },
            }
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      var charPiecurrentIndex=0;
      var _this=this;
      //自动高亮显示
      var chartHover = function () {
        // console.log(charPiecurrentIndex)
        var dataLen = option.series[0].data.length;
        // 取消之前高亮的图形
        lineEchart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
        charPiecurrentIndex = (charPiecurrentIndex + 1) % dataLen;
        // 高亮当前图形
        lineEchart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
        // 显示 tooltip
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
      };
      if (_this.startCharts) {
        clearInterval(_this.startCharts);
      }
      _this.startCharts = setInterval(chartHover, 5000);
      // 4、鼠标移出之后，恢复自动高亮
      lineEchart.on("mouseout", function (param) {
        if (_this.startCharts) {
          clearInterval(_this.startCharts);
        }
        _this.startCharts = setInterval(chartHover, 5000);
      });
      // 鼠标移动上去的时候的高亮动画
      lineEchart.on("mouseover", function (param) {
        if (_this.startCharts) {
          clearInterval(_this.startCharts);
        }
      });

    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.4rem 0.2rem;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}
.biaoge_pai ul li {
  height: 20%;
}
.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}
.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}
.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}
.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}
.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}
.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}
.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}
.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}
.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}
.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}
.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}
.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}
.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}
@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }
  100% {
    width: 98.5%;
  }
}
@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }
  100% {
    width: 88.5%;
  }
}
@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }
  100% {
    width: 68.5%;
  }
}
@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }
  100% {
    width: 40.5%;
  }
}
@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }
  100% {
    width: 22.5%;
  }
}
@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }
  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}

.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/layeraudit/component/dept-close-rate.vue